module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0617.86da86b7.jpg";